<template>
    <v-container>
        <v-row v-if="dealsChanged" class="justify-end">
            <site-button
                btnType="tile"
                colorClasses="calendar-add-btn"
                :colNum="1"
                @click-event="saveChanges"
                toolTip="Save Changes"
                iconString="far fa-save"
            ></site-button>
        </v-row>
        <v-row class="center">
            <v-col cols="12">
                <v-card style="position: relative;" :height="calendarHeight">
                    <div
                        style="position: absolute; top: 30%; left: 30%; width: 60%; height: 30%;"
                        id="attachArea"
                    ></div>
                    <h2>{{ partnerName }} Daily Deals</h2>
                    <!-- Calendar for days of week Mon,Tues,Wed,Thur,Fri,Sat,Sun --->
                    <v-calendar
                        ref="dealsCal"
                        v-model="tempVal"
                        :events="deals"
                        type="week"
                        @click:event="showEvent"
                        @mousedown:event="startDrag"
                        @mousedown:time="startTime"
                        @mousemove:time="mouseMove"
                        @mouseup:time="endDrag"
                        @mouseleave.native="cancelDrag"
                    >
                        <template v-slot:event="{ event, timed }">
                            <v-menu class="col-6" :attach="'#attachArea'" :close-on-content-click="false"
                                v-model="event.open" fixed>
                                <template v-slot:activator="{ on }" v-on="on">
                                    <v-flex style="flex-direction: column;" class="center">
                                        <v-row><p class="v-event-draggable">{{ event.name }}</p></v-row>
                                        <v-row>
                                            <v-col>
                                                <span>{{ event.dealItem }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <p v-if="event.dealType == dealTypeEnums.AMOUNT">${{ event.dealValue }}</p>
                                            <p v-if="event.dealType == dealTypeEnums.PERCENTAGE">
                                                {{ event.dealValue }}% Off
                                            </p>
                                            <p v-if="event.dealType == dealTypeEnums.BUYONEGET">
                                                Buy One Get {{ event.dealValue }}
                                            </p>
                                            <p v-if="event.dealType == dealTypeEnums.AMOUNTOFF">
                                                ${{ event.dealValue }} Off
                                            </p>
                                        </v-row>
                                    </v-flex>
                                    <div
                                        :style="'background-color: ' + event.color"
                                        v-if="timed"
                                        class="v-event-drag-bottom"
                                        @mousedown.stop="extendBottom(event)"
                                    ></div>
                                </template>
                                <v-card color="grey lighten-4" flat>
                                    <v-flex>
                                        <v-row class="center">
                                            <v-col cols="5">
                                                <v-text-field label="Deal Name" @input="dealChange" v-model="event.name"></v-text-field>
                                            </v-col>
                                            <v-col cols="5">
                                                <v-text-field label="Deal Item" @input="dealChange" v-model="event.dealItem"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="center">
                                            <v-col cols="5">
                                                <v-select
                                                    v-model="event.dealType"
                                                    @change="dealChange"
                                                    label="Deal Type"
                                                    :items="dealTypeItems"
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="5">
                                                <v-text-field
                                                    v-model="event.dealValue"
                                                    @input="dealChange"
                                                    type="number"
                                                    label="Deal Value"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-flex>
                                    <v-card-actions class="end">
                                        <v-btn text color="secondary" @click="deleteDeal(event)">
                                            Delete Deal
                                        </v-btn>
                                        <v-btn text color="secondary" @click="event.open = false">
                                            Close
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </template>
                    </v-calendar>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SiteButton from '../../components/common/SiteButton'
import DealTypeEnums from '../../assets/Enums/DealTypeEnum'
import { MongoMixins } from '../../mixins/mongo-mixins'
import moment from 'moment'
import utils from '../../utilities/utils';
import { ObjectId } from 'bson';

export default {
    name: 'business-offering',
    components: {
        'site-button': SiteButton,
    },
    mixins: [MongoMixins],
    data: () => ({
        tempVal: '',
        dealsChanged: false,
        deals: [],
        justDragged: false,
        showDialogModal: false,
        dragEvent: null,
        dragStart: null,
        createEvent: null,
        createStart: null,
        extendOriginal: null,
        selectedOpen: false,
    }),
    created() {
        const deals = this.$store.state.partnerData.dailyDeals;

        if (deals) {
            const dailyDeals = deals.map(deal => {
                const weekdayStart = moment(deal.start),
                    weekdayEnd = moment(deal.end)
                let startTime = moment()
                    .set('weekday', weekdayStart.get('weekday'))
                    .set('hours', weekdayStart.get('hour'))
                    .set('minutes', weekdayStart.get('minute'))
                let endTime = moment()
                    .set('weekday', weekdayEnd.get('weekday'))
                    .set('hours', weekdayEnd.get('hour'))
                    .set('minutes', weekdayEnd.get('minute'))

                if (weekdayStart.weekday === 7) {
                    startTime = startTime.subtract(7, 'days')
                }
                if (weekdayEnd.weekday === 7) {
                    endTime = endTime.subtract(7, 'days')
                }
                const dealDisplay = {
                    name: deal.name,
                    start: startTime.valueOf(),
                    end: endTime.valueOf(),
                    day: deal.day,
                    dealType: deal.dealType,
                    dealValue: deal.dealValue,
                    dealItem: deal.dealItem,
                    description: deal.description,
                    startDisplayDate: moment(startTime).format('YYYY-MM-DD HH:mm:ss a'),
                    endDisplayDate: moment(endTime).format('YYYY-MM-DD HH:mm:ss a'),
                    open: false,
                    timed: true,
                }
                console.log('startTime: ' + moment().set('isoWeekday', weekdayStart))
                return dealDisplay
            })
            this.deals = dailyDeals
        }
    },
    mounted(){
        this.$refs.dealsCal.scrollToTime('12:00');
    },
    methods: {
        openAddDealDialog() {
            this.showDialogModal = true
        },
        hideAddDealDialog() {
            this.showDialogModal = false
        },
        setShowDialogModal(newVal) {
            this.showDialogModal = newVal
        },
        dealChange(){
            console.log('dealChange ', this.rawDeals);
            console.log(this.$store.state.partnerData.dailyDeals);
            this.dealsChanged = this.dealsHaveChanged(this.rawDeals, this.$store.state.partnerData.dailyDeals);
        },
        saveChanges() {
            //partnerId refers to the id of the date-location or partner.
            const locationId = this.$store.state.partnerData.partnerId
            this.dealsChanged = false

            this.submitDailyDeals(locationId, this.deals).then(() => {
                this.$store.dispatch('UPDATE_DAILY_DEALS', this.deals)
            });
        },
        deleteDeal(event) {
            const index = this.deals.findIndex(s => s._id === event._id)
            this.deals.splice(index, 1)
            this.selectedOpen = false
            this.dealsChanged = this.dealsHaveChanged(this.rawDeals, this.initialDeals)
        },
        toTime(tms) {
            return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
        },
        startDrag({ event, timed }) {
            console.log('start drag')
            if (event && timed) {
                this.dragEvent = event
                this.dragTime = null
                this.extendOriginal = null
            }
        },
        startTime(tms) {
            const mouse = this.toTime(tms)

            if (this.dragEvent && this.dragTime === null) {
                const start = this.dragEvent.start

                this.dragTime = mouse - start
            } else {
                this.createStart = this.roundTime(mouse)
                this.createEvent = {
                    _id: new ObjectId(),
                    day: moment(this.createStart).isoWeekday(),
                    name: `Event ${this.deals.length}`,
                    dealType: DealTypeEnums.AMOUNT,
                    description: null,
                    dealValue: 0,
                    dealItem: '',
                    color: '#EE1D00',
                    start: this.createStart, // LONG used as date.
                    end: this.roundTime(mouse, false), // LONG used as date.
                    timed: true,
                    open: false,
                }

                this.deals.push(this.createEvent)
                this.dealsChanged = true
            }
        },
        extendBottom(event) {
            console.log('extend bottom')
            this.createEvent = event
            this.createStart = event.start
            this.extendOriginal = event.end
            this.justDragged = true
        },
        mouseMove(tms) {
            const mouse = this.toTime(tms)

            if (this.dragEvent && this.dragTime !== null) {
                const start = this.dragEvent.start
                const end = this.dragEvent.end
                const duration = end - start
                const newStartTime = mouse - this.dragTime
                const newStart = this.roundTime(newStartTime)
                const newEnd = newStart + duration

                this.dragEvent.start = newStart
                this.dragEvent.end = newEnd
                console.log('mm draging start: ' + this.dragEvent.start + ' end: ' + this.dragEvent.end)
            } else if (this.createEvent && this.createStart !== null) {
                const mouseRounded = this.roundTime(mouse, false)
                const min = Math.min(mouseRounded, this.createStart)
                const max = Math.max(mouseRounded, this.createStart)

                if (min < max) {
                    this.createEvent.start = min
                    this.createEvent.startTime = moment(min).format('HH:mm')
                    this.createEvent.end = max
                    this.createEvent.endTime = moment(max).format('HH:mm')
                }
                console.log('min < max')
            }
        },
        endDrag() {
            console.log('endDrag')
            this.dragTime = null
            this.dragEvent = null
            this.createEvent = null
            this.createStart = null
            this.extendOriginal = null
        },
        cancelDrag() {
            console.log('cancel drag')
            if (this.createEvent) {
                if (this.extendOriginal) {
                    this.createEvent.end = this.extendOriginal
                } else {
                    const i = this.deals.indexOf(this.createEvent)
                    if (i !== -1) {
                        this.deals.splice(i, 1)
                    }
                }
            }

            this.dealsChanged = this.dealsHaveChanged(this.rawDeals, this.initialDeals);
            this.createEvent = null
            this.createStart = null
            this.dragTime = null
            this.dragEvent = null
        },
        roundTime(time, down = true) {
            const roundTo = 60 // minutes
            const roundDownTime = roundTo * 60 * 1000

            return down ? time - (time % roundDownTime) : time + (roundDownTime - (time % roundDownTime))
        },

        showEvent({ nativeEvent, event }) {
            console.log('show')

            console.log('Not Dragged: ' + !this.justDragged)
            if (!this.justDragged) {
                console.log('opening')
                setTimeout(() => {
                    event.open = true
                    this.deals.$set()
                }, 10)
            }

            this.justDragged = false
            nativeEvent.stopPropagation()
        },
        dealsHaveChanged(deals, initialDeals){
            return utils.dealsHaveChanged(deals, initialDeals);
        }
    },
    computed: {
        today(){
            return new Date().setHours(15);
        },
        dealTypeItems() {
            return Object.values(DealTypeEnums)
        },
        dealTypeEnums() {
            return DealTypeEnums
        },
        rawDeals(){
            return this.deals.map(item => {
                item.startTime = moment(item.start).format('HH:mm');
                item.endTime = moment(item.end).format('HH:mm');
                return utils.omit(['startDisplayDate','endDisplayDate','open','start','end'], item);
            });
        },
        initialDeals(){
            return this.$store.state.partnerData.dailyDeals.map(deal => {
                return utils.omit(['color','open','start','end'], deal);
            });
        },
        calendarHeight() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '450'
                default:
                    return '500'
            }
        },
        partnerName() {
            return this.$store.state.partnerData.partnerName || '';
        },
    },
}
</script>

<style lang="scss" scoped>
.v-event-draggable {
    padding-left: 6px;
}

.v-event-timed {
    user-select: none;
    -webkit-user-select: none;
}

.v-event-drag-bottom {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid white;
    left: 0;
    right: 0;
    bottom: 0px;
    height: 20px;
    width: 100%;
    cursor: ns-resize;
    background: #2196f3;

    &::after {
        height: 4px;
        border-top: 1px solid white;
        border-bottom: 1px solid white;
        width: 16px;
        opacity: 0.8;
        content: '';
    }

    &:hover::after {
        display: block;
    }
}
</style>
